
webpack.register(
    'modules/viewing-schedule-old/viewing-schedule-old',
    function() {
        return import('modules/viewing-schedule-old/viewing-schedule-old');
    },
    true
);